/**
 * TUVI - Configuración Global del Frontend
 * Detecta automáticamente el entorno (desarrollo/producción)
 */

// Detectar si estamos en producción
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// URLs base según el entorno
export const API_BASE_URL = isProduction
  ? 'https://tuvisistema.com/api'
  : 'http://localhost/TUVI/api';

export const BACKEND_URL = isProduction
  ? 'https://tuvisistema.com/backend'
  : 'http://localhost/TUVI/backend';

export const UPLOADS_URL = isProduction
  ? 'https://tuvisistema.com/backend/uploads'
  : 'http://localhost/TUVI/backend/uploads';

// GraphQL API (nuevo VPS)
export const GRAPHQL_URL = 'https://api.tuvisistema.com/graphql';

// Upload API (nuevo VPS - REST para file uploads)
export const UPLOAD_URL = 'https://api.tuvisistema.com/upload';

// Función helper para construir URLs de archivos
export const getFileUrl = (relativePath) => {
  if (!relativePath) return null;
  // Si ya es una URL completa, devolverla
  if (relativePath.startsWith('http')) return relativePath;
  // Si empieza con uploads/, agregar BACKEND_URL
  if (relativePath.startsWith('uploads/')) {
    return `${BACKEND_URL}/${relativePath}`;
  }
  return `${BACKEND_URL}/${relativePath}`;
};

export default {
  API_BASE_URL,
  BACKEND_URL,
  UPLOADS_URL,
  getFileUrl,
  isProduction
};
